<template>
    <div class="card-details">
        <div class="row">
            <h5 class="col-sm-12 col-md-9 text-bold">{{ title }}</h5>

            <div class="hidden-sm col-md-3 text-center">
                <span class="icon icon-md" :class="[iconStyle, icon]" />
            </div>

            <div class="col-sm-12 col-md-12">
                <template>
                    <div class="small" v-if="count">
                        {{ count }}
                    </div>

                    <div class="small" v-else>
                        {{ weight }} {{ unit }} {{ count }}
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'DetailsCard',

  props: {
    title: String,
    weight: Number,
    unit: String,
    count: Number,
    icon: String,
    iconStyle: String
  }
}
</script>

